import { createSelector } from '@ngrx/store';
import { odataParamsFactory } from '@tdw/core';

import * as fromBase from './admin.selectors';
const selectFittingsState = createSelector(fromBase.selectAdminState, state => state.fittings);

export const selectFittingProductsOdataResult = createSelector(selectFittingsState, state => state.fittings);
export const selectFittingProducts = createSelector(selectFittingProductsOdataResult, result => result?.value);
export const selectFittingQuery = createSelector(selectFittingsState, state => state.fittingsQuery);
export const selectCurrentPage = createSelector(selectFittingQuery, q => q.skip === 0 ? 1 : Math.ceil((q.skip / q.top) + 1));
export const selectFittingAdminFilter = createSelector(selectFittingsState, state => state.fittingsAdminFilter);

export const selectConfigurationsOdataResult = createSelector(selectFittingsState, state => state.configurations);
export const selectConfigurationsQuery = createSelector(selectFittingsState, state => state.configurationsQuery);
export const selectConfigurationsCurrentPage = createSelector(selectConfigurationsQuery, q => q.skip === 0 ? 1 : Math.ceil((q.skip / q.top) + 1));

export const selectConfigurations = createSelector(selectConfigurationsOdataResult, result => result?.value);
export const selectConfigurationUiFilter = createSelector(selectFittingsState, state => state.configurationUiFilter);
export const selectConfigurationOdataFilter = createSelector(selectConfigurationUiFilter, fil => {
  let res = '';
  if (!!fil.suffix && fil.suffix.length > 0) res += `contains(suffix, '${fil.suffix}') AND `;
  if (!!fil.productNumber && fil.productNumber.length > 0) res += `contains(productNumber, '${fil.productNumber}') AND `;
  if (!!fil.productLine && fil.productLine.length > 0) res += `contains(productLine, '${fil.productLine}') AND `;
  if (fil.isActive === false || fil.isActive === true) res += `isActive eq ${fil.isActive} AND `;

  return res.substring(0, res.length - 5);
});

export const selectCurrentlyEditing = createSelector(selectFittingsState, state => state.currentlyEditing);
export const selectCurrentlyEditingFittingId = createSelector(selectCurrentlyEditing, state => state.fittingProduct?.id);
export const selectCurrentlyEditingFitting = createSelector(selectCurrentlyEditing, val => val?.fittingProduct);
export const selectCurrentlyEditingAssociateProducts = createSelector(selectCurrentlyEditing, val => val?.associatedProducts || []);

export const selectConfigurationQuery = createSelector(selectFittingsState, selectConfigurationOdataFilter,
  (state, odataFilter) => odataFilter.length > 0 ? odataParamsFactory({ ...state.configurationsQuery, filter: odataFilter }) : state.configurationsQuery);

export const selectAssociatedProductsQueryResult = createSelector(selectFittingsState, state => state.associatedProductsQueryResult);
